<template>
  <div class="dataTables_wrapper vld-parent">
    <loading :active.sync="isLoading"
             lock-scroll
             :is-full-page="false"
             color="#178e4c"

    ></loading>
    <b-row>
      <b-col md="5" sm="12">
        <c-table-length v-model.sync="pageSize"/>
      </b-col>

      <b-col md="7" sm="12" class="text-right">
        <slot name="button">
          <div class="dataTables_paginate" v-if="showTopPagination">
            <b-pagination v-if="recordsFiltered"
                          v-model="page"
                          :per-page="pageSize"
                          :total-rows="recordsFiltered"
                          align="right"
                          first-text="Trang đầu"
                          last-text="Trang cuối"
            />
          </div>
        </slot>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover dataTable" style="width: 100%">
            <thead>
            <tr>
              <c-table-column-head v-for="(item, index) in headerConfigs"
                                   :key="item.text"
                                   ref="headers"
                                   :sort-field="item.sortField"
                                   :sortable="item.sortable"
                                   :text="item.text"
                                   :width="item.width"
                                   @click="sort($event, index)"
                                   @click.ctrl="multiSort($event, index)"
              />
            </tr>
            </thead>

            <tbody>
            <tr v-if="!data.length">
              <td :colspan="headerConfigs.length" class="dataTables_empty">Không tìm thấy dữ liệu</td>
            </tr>

            <tr v-for="(item, index) in data" v-else :key="item.id">
              <slot :index="index + start" :item="{...item, index: index + start}">
                <td>{{ index }}</td>
                <td>{{ item.shopCode }}</td>
                <td>{{ item.shopName }}</td>
                <td>{{ item.name }}</td>
                <td></td>
              </slot>
            </tr>

            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="5" sm="12">
        <div aria-live="polite" class="dataTables_info" role="status">Đang xem dòng {{ start }} đến {{ end }} trong tổng số {{ recordsFiltered }} dòng
          dữ liệu
        </div>
      </b-col>

      <b-col md="7" sm="12">
        <div class="dataTables_paginate">
          <b-pagination v-if="recordsFiltered"
                        v-model="page"
                        :per-page="pageSize"
                        :total-rows="recordsFiltered"
                        align="right"
                        first-text="Trang đầu"
                        last-text="Trang cuối"
          />
        </div>
      </b-col>
    </b-row>


  </div>
</template>

<script>
import CTableLength from "@/components/Tables/CTableLength";
import CTableColumnHead from "@/components/Tables/CTableColumnHead";

export default {
  name: "CTable",
  components: {CTableColumnHead, CTableLength},
  props: {
    uri: String,
    dataFilter: {
      type: [Object, String, Number, Array],
      default: () => {
      }
    },
    headerConfigs: {
      type: Array,
      default: () => []
    },
    showTopPagination: Boolean,
    lazy: Boolean,
    processResData: Function,
    processReqData: Function,
    pageSize: {
      type: Number|String,
      default: 10
    },

  },
  data() {
    return {
      page: 1,
      headerConfig: [],
      data: [],
      recordsFiltered: 0,
      isLoading: false,
      order: []
    }
  },
  computed: {
    start() {
      if (this.data.length) {
        return (this.page - 1) * this.pageSize + 1;
      } else {
        return 0;
      }
    },
    end() {
      if (this.data.length) {
        return this.start + this.data.length - 1;
      } else {
        return 0;
      }
    },
    dataPost() {
      let obj = {
        page: this.page - 1,
        pageSize: this.pageSize,
        order: this.order || [],
        dataFilter: this.dataFilter || {}
      }

      return obj;
    }
  },
  beforeDestroy() {
    this.$root.$off('dateError', this.handleDateError);
  },
  mounted() {
    if(!this.lazy){
      this.reload();
    }
    this.$root.$on('dateError', this.handleDateError);
  },
  methods: {
    reload() {
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        let dataPost = this.dataPost;
        if(this.processResData){
          dataPost = this.processReqData(dataPost);
        }
        this.$http.post(this.uri, dataPost).then(res => {
          let dataRes = res.data;
          if(this.processResData){
            dataRes = this.processResData(dataRes);
          }
          this.data = dataRes.data;
          this.$emit('getData', dataRes.data) // bắn sự kiện getData với giá trị là dataRes.data sau khi call api thành công
          this.recordsFiltered = dataRes.recordsFiltered
          this.isLoading = false;
          resolve(dataRes);
        }).catch(error => {
          this.errorNotify(error);

          this.isLoading = false;
          this.data = [];
          reject(error);
        })
      });
    },
    multiSort(event, index) {

    },
    sort(event, index) {
      this.$refs.headers.forEach((value, i) => {
        if (index != i) {
          value.resetSort();
        }
      });
      this.$refs.headers[index].changeSortDir();

      let orderConfig = this.$refs.headers[index].getOrderConfig();
      if (orderConfig) {
        this.order = [orderConfig];
      } else {
        this.order = [];
      }
      this.reload();
    },
    handleDateError() {
      this.data = [];
    }
  },
  watch: {
    page: function (newValue, oldValue) {
      this.reload();

    },
    pageSize: function (newValue, oldValue) {
      this.reload();
    },
  }
}
</script>

<style scoped>

</style>